module.exports = __webpack_public_path__ + "static/media/call-inactive.02ae57af.svg";